import Example1 from "./Example1";
import Example2 from "./Example2";

function App() {
  return <Example1 />
}

export default App;
